import React from 'react';

import RouteProvider from 'providers/RouteProvider';
import ThemeProvider from 'providers/ThemeProvider';
import ReactQueryProvider from 'providers/ReactQueryProvider';

function App() {
    return (
        <ReactQueryProvider>
            <ThemeProvider>
                <RouteProvider />
            </ThemeProvider>
        </ReactQueryProvider>
    );
}

export default App;
